import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import ExternalContentIcon from '../icons/ExternalContentIcon/ExternalContentIcon';
import Icon from '../icons/Icon';
import Link from '../Link';
import NotificationsBubble from '../NotificationsBubble';
import LeadScanIcon from './inner/LeadScanIcon';
import QAIcon from './inner/QAIcon';
import ScheduleIcon from './inner/ScheduleIcon';
import TopBar from './TopBar';
import MapIcon from './inner/MapIcon';

class TopBarEvent extends React.Component {
    render() {
        let { event, returnURL = '..', virtualRoomContext, eventMapIcon } = this.props;

        let icons = [];
        if (!this.props.children && event.joined) {
            icons = this.props.icons || [
                <LeadScanIcon event={event} key="leadScan" isActive={this.props.leads} />,
                <ScheduleIcon event={event} isActive={this.props.schedule} key="schedule" />,
                <QAIcon event={event} key="qa" isActive={this.props.qa} />,
                event.settings.disable_participants_list ? null : (
                    <Link href={'/events/' + event.id + '/participants'} key="participants">
                        <Icon icon="event-participants" selected={this.props.participants}></Icon>
                    </Link>
                ),
                event.settings.disable_chat ? null : (
                    <Link href={'/events/' + event.id + '/chats'} key="chat">
                        <Icon icon="event-chat" selected={this.props.chat}>
                            <NotificationsBubble query={'events[' + event.id + '].notifications.newChatMessage'} />
                        </Icon>
                    </Link>
                ),
                event.settings.disable_meetings ? null : (
                    <Link href={'/events/' + event.id + '/meetings'} key="meetings">
                        <Icon icon="event-meetings" selected={this.props.meetings}>
                            <NotificationsBubble query={(state) => state.events[event.id].meetings.unconfirmedMeetings} />
                        </Icon>
                    </Link>
                ),
            ];
        } else {
            icons = this.props.icons || [];
        }

        if (this.props.hasExternalURLActive) {
            icons.push(
                <Link className="mobile-only" key="webinar" onClick={this.handleOpenSidePanel.bind(this)}>
                    <ExternalContentIcon session_content_type={virtualRoomContext?.session_content_type} />
                </Link>
            );
        }

        if (eventMapIcon) {
            icons.push(<MapIcon key="map" event={event} />);
        }

        return (
            <TopBar returnURL={returnURL} onReturnClick={this.props.onReturnClick} showLogo={this.props.showLogo} customColor={event.settings?.primary_color} icons={icons} style={this.props.style}>
                {this.props.children}
            </TopBar>
        );
    }

    handleOpenSidePanel() {
        app.store.dispatch(app.actions.ui.sidePanel.maximize(true));
    }
}

export default connect((state, props) => {
    const hasExternalURLActive = _(state).get(`ui.sidePanel.externalURL`, false),
        activeVirtualRoomId = _(state).get(`ui.sidePanel.virtualRoom.programId`, null),
        virtualRoomContext = _(state).get(`events[${props.event.id}].schedule.indexed[${activeVirtualRoomId}]`);

    return {
        hasExternalURLActive,
        virtualRoomContext,
    };
})(TopBarEvent);
